import { render } from "./RecycledParts.vue?vue&type=template&id=0e56423f"
import script from "./RecycledParts.vue?vue&type=script&lang=js"
export * from "./RecycledParts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__